import * as React from 'react';
import { GroupBase, components } from 'react-select';

// a checkbox dropdown can name its own summary, e.g. "All", in place of the count
declare module 'react-select/dist/declarations/src/Select' {
  export interface Props<Option, IsMulti extends boolean, Group extends GroupBase<Option>> {
    summaryText?: string;
  }
}

export const CheckableDropdownValueContainer = props => {
  const { children, selectProps } = props;
  const { optionType, optionTypePlural, optionTypeDescriptor, value, allOptionsAreSelected, summaryText } = selectProps;

  const optionTypeDescriptorOrEmptyString = optionTypeDescriptor || '';
  const pluralType = optionTypePlural || `${optionType}s`;

  let text = `${value.length} ${value.length === 1 ? optionType : pluralType} ${optionTypeDescriptorOrEmptyString}`;
  if (allOptionsAreSelected) {
    text = `All ${pluralType} ${optionTypeDescriptorOrEmptyString}`;
  }
  if (summaryText) {
    text = summaryText;
  }

  return (
    <components.ValueContainer {...props}>
      <div className="custom-dropdown-value-container">
        <div className="multi-option-summary-text">{text}</div>
      </div>
      {children}
    </components.ValueContainer>
  );
};
